import { useBucket } from '@mc/experiments-react'
import Script from 'next/script'

const APOLLO_FLAG = 'web_flw-741_apollo'

export const Apollo = () => {
  const bucket = useBucket(APOLLO_FLAG)

  if (bucket !== 'variant_1') return null

  return (
    <Script
      id='apollo'
      dangerouslySetInnerHTML={{
        __html: `function initApollo(){var n=Math.random().toString(36).substring(7),o=document.createElement("script");
o.src="https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache="+n,o.async=!0,o.defer=!0,
o.onload=function(){window.trackingFunctions.onLoad({appId:"66311872b8e7aa01c71e965a"})},
document.head.appendChild(o)}initApollo();
        `,
      }}
    />
  )
}
